import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import ElementsView from './ElementsView/ElementsView';
import VariablesView from './VariablesView/VariablesView';

const ElementsMenu = ({
  handleToolbarElements,
  dragStart,
  dragEnd,
  showAttachmentModal,
  openVariablesList,
  setOpenVariablesList,
  isSection,
}) => {
  const [showVariables, setShowVariables] = useState(false);

  useEffect(() => {
    setShowVariables(openVariablesList);
  }, [openVariablesList]);

  return (
    <>
      <ElementsView
        handleToolbarElements={handleToolbarElements}
        dragStart={dragStart}
        dragEnd={dragEnd}
        showAttachmentModal={showAttachmentModal}
        openVariablesList={openVariablesList}
        setOpenVariablesList={setOpenVariablesList}
        showVariables={showVariables}
        setShowVariables={setShowVariables}
      />
      <VariablesView
        openVariablesList={openVariablesList}
        showVariables={showVariables}
        setOpenVariablesList={setOpenVariablesList}
        setShowVariables={setShowVariables}
        isSection={isSection}
      />
    </>
  );
};

ElementsMenu.propTypes = {
  handleToolbarElements: PropTypes.func.isRequired,
  dragStart: PropTypes.func.isRequired,
  dragEnd: PropTypes.func.isRequired,
  showAttachmentModal: PropTypes.func.isRequired,
  wixEditor: PropTypes.bool,
  templateWixEditor: PropTypes.bool,
  wixPricing: PropTypes.object,
};

export default ElementsMenu;
